import { ReactNode, useState } from "react";
import { ContextMenuContext } from "./context-menu.context";

export type ContextMenuProviderProps = {
  children: ReactNode;
};

export function ContextMenuProvider({ children }: ContextMenuProviderProps) {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [componentVariant, setComponentVariant] = useState<string>("primary");

  return (
    <ContextMenuContext.Provider value={{ isOpen, setIsOpen, componentVariant, setComponentVariant}}>
      {children}
    </ContextMenuContext.Provider>
  );
}
